<script lang="ts">
    import { Table } from 'sveltestrap'
    import Time from 'svelte-time'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import {getUserPurchases} from 'src/components/cabinet/#services/getUserPurchases'

    export let userId

    let currentPage = 0
    let perPage = 25
    let loadingTransactions = []

    loadingTransactions.length = perPage
    getUserPurchases.reset()

    function filter() {
        getUserPurchases.send({ data: { userId, page: currentPage + 1, perPage }})
        $getUserPurchases.value
    }
    $:currentPage,perPage,userId,filter()

    const productDescription = {
        'offer_additional_hangar1_gp': 'Additional hangar 1',
        'offer_additional_hangar2_gp': 'Additional hangar 2',
        'offer_auto_merge_gp': 'Auto merge offer',
        'offer_last_chance2_gp': 'Last chance 2 offer',
        'offer_last_chance3_gp': 'Last chance 3 offer',
        'offer_last_chance4_gp': 'Last chance 4 offer',
        'offer_last_chance_gp': 'Last chance offer',
        'offer_offline_earning_gp': 'Offline earning offer',
        'offer_starter_pack_gp': 'Starter pack offer',
        'starter_pack_gp': 'Starter pack offer',
        'offer_wall_street_card_gp': 'Wall street card offer',
        'offer_weekly_tournament_gp': 'Weekly tournament offer',
        'offer_xmas_special_gp': 'Christmas offer',
        'soul_buy1_gp': 'Bought LIS 1',
        'soul_buy2_gp': 'Bought LIS 2',
        'soul_buy3_gp': 'Bought LIS 3',
        'soul_buy4_gp': 'Bought LIS 4',
        'soul_buy5_gp': 'Bought LIS 5',
        'soul_buy6_gp': 'Bought LIS 6',
        'status_buy3_gp': 'Silver membership',
        'status_buy4_gp': 'Gold membership',
        'status_buy5_gp': 'Platinum membership',
    }
</script>

<div class="transactions-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Game</td>
            <td class="text-center">Product</td>
            <td class="text-center">Order ID</td>
            <td class="text-center">Date</td>
        </tr>
        </thead>
        <tbody>
        {#if $getUserPurchases.loading}
            {#each {length:perPage} as item}
                <tr>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getUserPurchases.error || !$getUserPurchases.hasValue }
            <tr>
                <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else}
            {#each $getUserPurchases.value.purchases as { appId, userId, orderId, productId, email, createdAt }}
                <tr>
                    <td>
                        {#if appId === 3}
                            Cats
                        {:else if [5,6].includes(appId)}
                            Dragons
                        {:else if appId === 7}
                            Foxes
                        {:else if appId === 11}
                            Dogs
                        {:else if appId === 13}
                            Elon
                        {:else if appId === 15}
                            Pepe
                        {/if}
                    </td>
                    <td class="text-center">
                        {#if productDescription[productId]}
                            <span title="{productId}">{productDescription[productId]}</span>
                        {:else}
                            {productId}
                        {/if}
                    </td>
                    <td class="text-center notranslate">
                        <a href="https://play.google.com/console/u/0/developers/5329690909234469933/orders/{orderId}" target="_blank" rel="noreferrer">
                            {orderId}
                        </a>
                    </td>
                    <td class="text-center"><Time relative timestamp={createdAt}/></td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="4">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $getUserPurchases.hasValue}
        <PerPage bind:perPage={perPage} disabled={$getUserPurchases.loading || $getUserPurchases.loading}/>
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getUserPurchases.value.totalCount}
            {perPage}
            disabled={$getUserPurchases.loading || $getUserPurchases.loading}
        />
    {/if}
</div>

<style>
    .transactions-list :global(table) {
        width: auto;
    }

    .transactions-list :global(td) {
        vertical-align: middle;
        padding: 12px 25px;
        line-height: normal;
    }

    .transactions-list :global(nav .pagination) {
        justify-content: flex-start;
    }
</style>
